import { Page } from 'layouts/Page';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EUDR } from 'components/EUDR';
import { getUserInfo } from 'redux/reducers/user/selectors';
import { ROLES } from 'routes/constants';
import { Box, Typography } from '@mui/material';

export const EUDRPage: FC = () => {
	// const userinfo = useSelector(getUserInfo);
	const userinfo = {
		roles: [{ roleNameUI: ROLES.ADMIN }, { roleNameUI: ROLES.EUDR }],
	};

	const hasPermission = useMemo(
		() =>
			userinfo?.roles?.some(
				(role) => role.roleNameUI === ROLES.ADMIN || role.roleNameUI === ROLES.EUDR,
			),
		[userinfo?.roles],
	);

	return (
		<Page title="EUDR – EAS Control Center">
			{hasPermission ? (
				<EUDR />
			) : (
				<Box sx={{ p: 2 }}>
					<Typography variant="h6">You do not have permission to view this page.</Typography>
				</Box>
			)}
		</Page>
	);
};
